export enum PackageTypeCatagory {
  INDIVIDUAL = 'P',
  GROUP = 'G',
  FAMILY = 'F'
}

export enum PackageTypeCatagoryFull {
  INDIVIDUAL = 'INDIVIDUAL',
  GROUP = 'GROUP',
  FAMILY = 'FAMILY'
}

export enum ChannelType {
  DIRECT = 'DIRECT',
  INTERMEDIARY = 'INTERMEDIARY'
}

export enum InsuranceTypeCatagory {
  OUTBOUND = 'Outbound',
  INBOUND = 'Inbound',
  DOMESTIC = 'Domestic'
}

export enum TravelType {
  SINGLE_TRIP = 'SINGLE_TRIP',
  ANNUAL_TRIP = 'ANNUAL_MULTI_TRIP'
}

export enum StatusMode {
  INITIAL = 'INITIAL',
  VIEW = 'VIEW',
  EDIT = 'EDIT'
}

export enum getPriceErrorType {
  NOT_FOUND = 'NOT_FOUND',
  UNEXPECTED = 'UNEXPECTED'
}
